import { debounce } from '../utils/_debounce'
import Swiper from 'swiper/bundle'

const zipcodes = require('../../../assets/json/zipcodes.json')
const $ = jQuery

export default function Search () {
  const WRAPPERS = document.querySelectorAll('.mtt-search')
  if (WRAPPERS.length > 0) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      const WRAPPER = WRAPPERS[i]
      const Search = new SearchClass(WRAPPER)
      Search.init()
      const StickyLetters = new StickyLettersClass(WRAPPER)
      StickyLetters.init()
    }
  }
}

class SearchClass {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.INPUT_WRAP = this.WRAPPER.querySelector('.mtt-search-cover__input')
    this.INPUT = this.WRAPPER.querySelector('.mtt-search-cover__input input')
    this.TARGET = this.WRAPPER.querySelector('.mtt-search-cover__results')
    this.LOADER = this.WRAPPER.querySelector('.mtt-search-cover__loader')
    this.data = {
      action: 'city_search',
      search_term: ''
    }
  }

  init () {
    if (this.INPUT && this.TARGET) {
      // search
      this.INPUT.addEventListener('keyup', debounce((e) => {
        this.data.search_term = this.lookupZipcode(this.INPUT.value)
        this.doSearch()
      }, 300))

      // click outside
      document.addEventListener('click', (e) => {
        !this.INPUT_WRAP.contains(e.target) && this.hideResults()
      })
    }

    this.letterSlider()
  }

  lookupZipcode (value) {
    const result = zipcodes.filter(entry => entry.code.indexOf(value) !== -1)
    return result.length > 0 ? result[0].city : value
  }

  beforeSearch () {
    this.showLoader()
  }

  afterSearch () {
    this.hideLoader()
    this.data.search_term === '' ? this.hideResults() : this.showResults()
  }

  showLoader () {
    this.WRAPPER.classList.add('loading')
    this.LOADER.classList.add('show')
  }

  hideLoader () {
    this.WRAPPER.classList.remove('loading')
    this.LOADER.classList.remove('show')
  }

  showResults () {
    this.TARGET.classList.add('show')
  }

  hideResults () {
    this.TARGET.classList.remove('show')
  }

  doSearch () {
    this.beforeSearch()
    jQuery.post(main_theme_objects.ajax_url, this.data, (res) => {
      if (res !== 0) {
        this.TARGET.innerHTML = res.markup
        this.afterSearch()
      }
    })
  }

  letterSlider () {
    const SWIPER = new Swiper('.mtt-search-index__letters .swiper-container', {
      init: false,
      slidesPerView: 10,
      speed: 800,
      spaceBetween: 0,
      watchOverflow: true,
      freeMode: true,
      breakpoints: {
        401: {
          slidesPerView: 12
        },
        601: {
          slidesPerView: 15
        },
        801: {
          slidesPerView: 20
        },
        1001: {
          slidesPerView: 29
        }
      }
    })

    SWIPER.init()
  }
}

class StickyLettersClass {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.WRAP = this.WRAPPER.querySelector('.mtt-search-index__letters-outer')
    this.WRAP_INNER = this.WRAPPER.querySelector('.mtt-search-index__letters')
    this.MAIN_HEADER = document.getElementById('main_header')
    this.LETTERS = this.WRAPPER.querySelectorAll('.mtt-search-index__letter')
    this.SECTION_LETTERS = this.WRAPPER.querySelectorAll('.mtt-search-index__section-letter')
    this.isSticky = false
  }

  init () {
    if (this.WRAP && this.MAIN_HEADER) {
      this.scrollEvent()
      window.addEventListener('scroll', () => this.scrollEvent())
      this.setupDisabledLetters()
      this.letterClickEvent()
    }
  }

  setupDisabledLetters () {
    if (this.LETTERS.length > 0) {
      for (let i = 0; i < this.LETTERS.length; i++) {
        const LETTER = this.LETTERS[i]
        const ID = LETTER.getAttribute('data-id')
        const SECTION_LETTER = this.getSectionLetter(ID)
        if (SECTION_LETTER === null) {
          LETTER.classList.add('disabled')
        }
      }
    }
  }

  letterClickEvent () {
    if (this.LETTERS.length > 0) {
      for (let i = 0; i < this.LETTERS.length; i++) {
        const LETTER = this.LETTERS[i]
        const ID = LETTER.getAttribute('data-id')
        const SECTION_LETTER = this.getSectionLetter(ID)

        if (SECTION_LETTER) {
          LETTER.addEventListener('click', () => {
            const offset = this.getLetterOffset()
            this.scroll(SECTION_LETTER, offset)
          })
        }
      }
    }
  }

  getSectionLetter (id) {
    if (this.SECTION_LETTERS.length > 0) {
      for (let i = 0; i < this.SECTION_LETTERS.length; i++) {
        const LETTER = this.SECTION_LETTERS[i]
        const ATTR = LETTER.getAttribute('data-letter')
        if (ATTR === id) return LETTER
      }
      return null
    }
    return null
  }

  scrollEvent () {
    // sticky to top
    const y = this.WRAP.getBoundingClientRect().top
    const offset = this.getAdminbarHeight() + this.getHeaderHeight()
    if (y <= offset) {
      if (!this.isSticky) {
        this.WRAP.classList.add('is-sticky')
        this.WRAP_INNER.style.top = offset + 'px'
        this.WRAP_INNER.style.position = 'fixed'
        this.isSticky = true
      }
    } else {
      if (this.isSticky) {
        this.WRAP.classList.remove('is-sticky')
        this.WRAP_INNER.style.top = ''
        this.WRAP_INNER.style.position = ''
        this.isSticky = false
      }
    }

    // hide when scrolled past section
    const wrapperBoundingRect = this.WRAPPER.getBoundingClientRect()
    const wrapperOffset = wrapperBoundingRect.top + wrapperBoundingRect.height
    if (wrapperOffset < 0) {
      this.WRAP_INNER.style.opacity = 0
      this.WRAP_INNER.style.visibility = 'hidden'
    } else {
      this.WRAP_INNER.style.opacity = ''
      this.WRAP_INNER.style.visibility = ''
    }

    // active letters
    if (this.LETTERS.length > 0 && this.SECTION_LETTERS.length > 0) {
      for (let i = 0; i < this.LETTERS.length; i++) {
        const LETTER = this.LETTERS[i]
        const ID = LETTER.getAttribute('data-id')
        const SECTION_LETTER = this.getSectionLetter(ID)
        const offset = this.getLetterOffset()

        if (SECTION_LETTER && SECTION_LETTER.getBoundingClientRect().top <= offset) {
          $(LETTER).addClass('active').siblings().removeClass('active')
        } else {
          LETTER.classList.remove('active')
        }
      }
    }
  }

  /**
   * Get height of adminbar if it exists
   */
  getAdminbarHeight () {
    const ADMIN_BAR = document.getElementById('wpadminbar')
    return ADMIN_BAR ? ADMIN_BAR.getBoundingClientRect().height : 0
  }

  getHeaderHeight () {
    return this.MAIN_HEADER ? this.MAIN_HEADER.getBoundingClientRect().height : 0
  }

  getWrapHeight () {
    return this.WRAP_INNER ? this.WRAP_INNER.getBoundingClientRect().height : 0
  }

  getLetterOffset () {
    return this.getAdminbarHeight() + this.getHeaderHeight() + this.getWrapHeight()
  }

  /**
   * Get screen width
   */
  getScreenWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }

  isElementInViewport (el, top = 0, bottom = 0) {
    const rect = el.getBoundingClientRect()
    return rect.top <= top && rect.bottom > bottom
  }

  scroll (el, offset = 0) {
    $('html, body').animate({
      scrollTop: $(el).offset().top - offset
    }, 800)
  }
}
